export const serverUrl = process.env.NODE_ENV.includes('production')
  ? 'https://api.voicit.com'
  : 'https://app.dev.plt.voicit.com';
export const baseUrl = process.env.REACT_APP_DOMAIN_URL;
const adminBasePath = '/admin-api';
export const endpoints = {
  auth: `/user-api/auth`,
  users: `${adminBasePath}/users`,
  kpis: `${adminBasePath}/kpis`,
  kpisFunctionalites: `${adminBasePath}/kpis/secondary`,
  kpisActivation: `${adminBasePath}/kpis/activation`,
  workspaces: `${adminBasePath}/workspaces`,
  subscriptions: `/user-api/subscriptions`,
  seats: `/user-api/seats`,
  products: `/user-api/products`,
  stripeStats: `/user-api/subscriptions/stripe-stats`,
  stripeSync: `/user-api/subscriptions/syncStripe`,
  tokenUsage: `/nlp-api/token-usage`,
};
export const authHeader = 'x-voicit-auth';
